import React, { Component } from 'react';

class TwitterShareButton extends Component {
    constructor(props){
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    windowOpen(url, _ref) {

        var height = (typeof _ref === 'undefined' || typeof _ref.height === 'undefined') ? 400 : _ref.height;
        var width = (typeof _ref === 'undefined' || typeof _ref.width === 'undefined') ? 550 : _ref.width;

        var left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
        var top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;

        var config = {
            height: height,
            width: width,
            left: left,
            top: top,
            location: 'no',
            toolbar: 'no',
            status: 'no',
            directories: 'no',
            menubar: 'no',
            scrollbars: 'yes',
            resizable: 'no',
            centerscreen: 'yes',
            chrome: 'yes'
        };

        var features = "height=" + config.height + ", " +
            "width=" + config.width + ", " +
            "left=" + config.left + ", " +
            "top=" + config.top + ", " +
            "location=" + config.location + ", " +
            "toolbar=" + config.toolbar + ", " +
            "status=" + config.status + ", " +
            "directories=" + config.directories + ", " +
            "menubar=" + config.menubar + ", " +
            "scrollbars=" + config.scrollbars + ", " +
            "resizable=" + config.resizable + ", " +
            "centerscreen=" + config.centerscreen + ", " +
            "chrome=" + config.chrome
            ;

        return window.open(url, '', features);
    }

    handleClick(event){
        event.preventDefault();

        if(typeof this.props.clickCallback === 'function'){
            this.props.clickCallback.call(null, event);
        }

        var url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(this.props.url) + '&text=' + encodeURIComponent(this.props.title);

        if(typeof this.props.via === 'string' && this.props.via !== ''){
            url += '&via=' + this.props.via;
        }

        this.windowOpen(url);
        
        return false;
    }

    render(){
        return(
            <div className="isg_share_button" onClick={this.handleClick}>
                {this.props.children}
            </div>
        );
    }
}

/*
 url={tweetUrl}
 title={tweetBody}
 className="isg_share_button"
 */

TwitterShareButton.propTypes = {
    children: React.PropTypes.node,
    url: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    via: React.PropTypes.string,
    clickCallback: React.PropTypes.func
};

export default TwitterShareButton;


/** WEBPACK FOOTER **
 ** ./src/components/TwitterShareButton.js
 **/